/**
 * Loads the GeniusChat widget.
 *
 * The widget boots hidden and is controlled through the `$chat` client built in
 * `./index.js`. User identity is passed to GeniusChat via a session token that
 * is fetched from the ImportScan profile endpoint before the widget script is
 * injected (mirrors the iscanv2 integration).
 *
 * @param {Function} readyCallback - Runs once GeniusChat has signalled it is ready.
 */
export default function installGeniusChat(readyCallback) {
  // Read each value as a full `process.env.X` expression so webpack inlines it
  // at build time — destructuring `process.env` leaves a bare `process`
  // reference that does not exist in the browser.
  const GENIUSCHAT_API_URL = process.env.GENIUSCHAT_API_URL || ''
  const GENIUSCHAT_WIDGET_URL = process.env.GENIUSCHAT_WIDGET_URL || ''
  const IMPORTSCAN_AWS_URL = process.env.IMPORTSCAN_AWS_URL || ''

  if (!GENIUSCHAT_API_URL || !GENIUSCHAT_WIDGET_URL) {
    return
  }

  window.GeniusChatConfig = {
    apiUrl: GENIUSCHAT_API_URL,
    flow: 'importgenius-assistant',
    enableRemoteTriggers: true,
    // Boot hidden; the navbar chat button controls visibility.
    visible: false
  }

  if (!Array.isArray(window.GeniusChatReady)) {
    window.GeniusChatReady = []
  }

  window.GeniusChatReady.push(() => {
    // Pass the authenticated user's identity via the session token.
    window.GeniusChat?.updateSessionContext(
      null,
      null,
      window.GeniusChatConfig.sessionToken
    )

    if (readyCallback) {
      readyCallback()
    }
  })

  async function injectScript() {
    try {
      const authToken = localStorage.getItem('auth._token.auth0') || ''
      const res = await fetch(`${IMPORTSCAN_AWS_URL}/profile?format=jwt`, {
        headers: { Authorization: authToken }
      })
      if (res.ok) {
        const data = await res.json()
        window.GeniusChatConfig.sessionToken = data.token
      }
    } catch (e) {
      // Load the widget without a token if the profile fetch fails.
    }

    const script = document.createElement('script')
    script.src = GENIUSCHAT_WIDGET_URL
    script.crossOrigin = 'anonymous'
    script.defer = true
    document.head.appendChild(script)
  }

  injectScript()
}
